import Close from '../assets/close.svg?react'

interface ITagPillProps {
  label: string
  imageUrl?: string | null
  onRemove: () => void
}

export const TagPill = ({ label, imageUrl, onRemove }: ITagPillProps) => {
  return (
    <div
      className={
        `flex items-center gap-2 bg-noteTagBackground rounded-full ${imageUrl ? 'pl-1' : 'pl-4'} pr-3 py-1`
      }
    >
      {imageUrl && (
        <img
          src={imageUrl}
          alt={label}
          className="w-8 h-8 rounded-full object-cover"
        />
      )}
      <span className={'text-base'}>{label}</span>
      <button
        type="button"
        onClick={onRemove}
        className={'hover:bg-searchBorder rounded p-1 transition-colors cursor-pointer'}
      >
        <Close width={12} height={12} />
      </button>
    </div>
  )
}
